import Box from '@eversports/klimt-primitives/legacy/Box'
import { motion } from '@eversports/klimt-utilities/framer-motion'

import usePrefersReducedMotion from '../../../../hooks/use-prefers-reduced-motion'

// Figma "Vector 8": a decorative line that draws itself in once, threading behind the voucher
// banner card - poking out above its top-right corner and bleeding past its right and bottom edges.
const LINE_WIDTH = 586
const LINE_HEIGHT = 207
const LINE_PATH =
  'M578.5 98.8519C564.379 85.1273 527.166 27.5895 474.509 59.6576C448.991 75.1983 402.535 117.479 428.844 133.295C455.154 149.111 516.738 16.5043 425.281 7.79431C305.252 -3.63686 142.141 323.024 7.50038 147.645'
const LINE_COLOR = '#21A696'
const LINE_STROKE_WIDTH = 15
const LINE_ROTATION_DEGREES = -20

// The line's rotated bounding box, positioned relative to the voucher banner card's right edge and
// bottom edge (bleeding 185px past the former, 78px past the latter - per Figma "Vector 8").
const BOUNDING_BOX_WIDTH = 602
const BOUNDING_BOX_HEIGHT = 375

// `pathLength` normalises the path to a length of 1, so the dash array trims it by fraction:
// `0 1` is an undrawn line, `1 1` a fully drawn one.
const UNDRAWN_LINE = '0 1'
const DRAWN_LINE = '1 1'

const DRAW_TRANSITION = {
  duration: 2,
  times: [0, 0.75, 1],
  ease: [[0.25, 0.1, 0.25, 1], 'linear'],
}

export function VoucherLineAnimation() {
  const prefersReducedMotion = usePrefersReducedMotion()

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '-5%',
        right: '-15%',
        zIndex: 0,
        width: BOUNDING_BOX_WIDTH,
        height: BOUNDING_BOX_HEIGHT,
        pointerEvents: 'none',
        display: { xs: 'none', md: 'block' },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: LINE_WIDTH,
          height: LINE_HEIGHT,
          transform: `translate(-50%, -50%) rotate(${LINE_ROTATION_DEGREES}deg)`,
        }}
      >
        <svg
          width={LINE_WIDTH}
          height={LINE_HEIGHT}
          viewBox={`0 0 ${LINE_WIDTH} ${LINE_HEIGHT}`}
          fill="none"
          aria-hidden
          style={{ display: 'block' }}
        >
          <motion.path
            d={LINE_PATH}
            stroke={LINE_COLOR}
            strokeWidth={LINE_STROKE_WIDTH}
            strokeLinecap="round"
            pathLength={1}
            initial={{ strokeDasharray: UNDRAWN_LINE, strokeDashoffset: 0 }}
            animate={{ strokeDasharray: prefersReducedMotion ? DRAWN_LINE : [UNDRAWN_LINE, DRAWN_LINE, DRAWN_LINE] }}
            transition={prefersReducedMotion ? { duration: 0 } : DRAW_TRANSITION}
          />
        </svg>
      </Box>
    </Box>
  )
}
